import { render, staticRenderFns } from "./eItems.vue?vue&type=template&id=59877e90&"
import script from "./eItems.vue?vue&type=script&lang=js&"
export * from "./eItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports